export const productFormSchema = {
  type: 'object',
  required: ['name', 'productCategoryId'],
  properties: {
    name: { type: 'string', minLength: 6, maxLength: 255 },
  },
};
